/**
 * @generated SignedSource<<7902bdbcb05104d39792eecdedc10e89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoteButtons_votable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesSubmissionAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDownAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpVoteButton_votable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DownVoteButton_votable"
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
};

node.hash = "448763ed97b7e589d40ecf01d5f6294a";

module.exports = node;
